import React from "react";
import { useFilterStateController } from "../../state/filter-state-controller.context";

interface ApplyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode;
}

export function ApplyButton({ children, disabled, type, onClick, ...buttonProps }: ApplyButtonProps): JSX.Element {
    const controller = useFilterStateController();

    const isDisabled = disabled ?? (controller ? !controller.hasPendingChanges : false);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);
        if (event.defaultPrevented) {
            return;
        }
        controller?.apply();
    };

    return (
        <button
            {...buttonProps}
            type={type || "button"}
            disabled={isDisabled}
            onClick={handleClick}
        >
            {children}
        </button>
    );
}
